export default "__VITE_ASSET__Hi95BHpW__"